import React, { useRef, useEffect, useState } from 'react';
import embed, { VisualizationSpec } from 'vega-embed';

type VegaChartProps = {
  spec: VisualizationSpec;
  actions?: boolean;
  // คลิก mark (แท่ง/ชิ้น donut) แล้วได้ datum ของ mark นั้นกลับมา — ไม่ส่ง prop = พฤติกรรมเดิมทุกอย่าง
  onItemClick?: (datum: any) => void;
};

const CardMCVegaChart = ({ spec, actions = false, onItemClick }: VegaChartProps) => {
  const chartRef = useRef<HTMLDivElement>(null);
  const [view, setView] = useState<any>(null);

  // เก็บใน ref เพื่อไม่ต้องเพิ่มเข้า deps — callback identity เปลี่ยนแล้วไม่ re-embed (ผู้ใช้เดิมไม่กระทบ)
  const onItemClickRef = useRef(onItemClick);
  onItemClickRef.current = onItemClick;

  useEffect(() => {
    if (chartRef.current) {
      const run = async () => {
        try {
          // Type assertion to bypass potential compatibility issues if types are missing
          const res = await embed(chartRef.current as HTMLElement, spec, {
            actions,
            mode: 'vega-lite',
            renderer: 'canvas', // or 'svg'
          });
          res.view.addEventListener('click', (_event: any, item: any) => {
            if (item?.datum && onItemClickRef.current) onItemClickRef.current(item.datum);
          });
          setView(res.view);
        } catch (error) {
          console.error("Vega Embed Error:", error);
        }
      };
      run();
    }
  }, [spec, actions]);

  // Clean up view on unmount
  useEffect(() => {
    return () => {
      if (view) {
        view.finalize();
      }
    };
  }, [view]);

  return <div ref={chartRef} style={{ width: '100%', height: '100%' }} />;
};

export default CardMCVegaChart;
